@switch (status) {
  @case ('WORKFLOW_INITIAL') {
    <app-tag type="info" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @case ('WORKFLOW_UPLOAD_PROCESSED') {
    <app-tag type="info" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @case ('WORKFLOW_IN_REVIEW') {
    <app-tag type="notice" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @case ('WORKFLOW_EDITING_CONFLICTS') {
    <app-tag type="warning" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @case ('WORKFLOW_MERGING') {
    <app-tag type="success" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @case ('WORKFLOW_FINISHED') {
    <app-tag type="success" size="small">
      {{ `models.branch.state.options.${status}` | translate }}
    </app-tag>
  }
  @default {
    <app-tag type="info" size="small">
      {{ status }}
    </app-tag>
  }
}
